import { useMemo } from 'react'

import { useModals, useSetState, useShowModal } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import handleCallbackAction, { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import CreateCampaignContactModal from '@modals/CreateCampaignContactModal'
import CreateOrEditContactModal from '@modals/CreateOrEditContactModal'

import type { CampaignContactModel, ContactModel } from '@models/types'

import PageContent from './components/PageContent'

const defaultState = {
  showCreateOrEditContactModal: false,
  showCreateCampaignContactModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

/* eslint-disable no-undef */
const callbacks = (component: keyof typeof componentCallbacks, setState: SetState) => {
  const componentCallbacks = {
    CreateOrEditContactModal: {
      closeModal: () => setState({ showCreateOrEditContactModal: false }),
      createContact: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      createContactUser: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      shareMobileLink: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      updateContact: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
    CreateCampaignContactModal: {
      closeModal: () => setState({ showCreateCampaignContactModal: false }),
      createCampaignContact: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}
const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showCreateOrEditContactModal } = state
  const { showCreateCampaignContactModal } = state

  const modalContext = useModals({ setState })
  const { callbacks: { setModalData } } = modalContext

  const pageContext = useMemo(() => ({
    callbacks: {
      showCreateOrEditContactModal: (payload: { contact: ContactModel }) => {
        setModalData('CreateOrEditContactModal', payload)
        setState({ showCreateOrEditContactModal: true })
      },
      showCreateCampaignContactModal: (payload: { campaignContact: CampaignContactModel }) => {
        setModalData('CreateCampaignContactModal', payload)
        setState({ showCreateCampaignContactModal: true })
      },
    },
  }), [])

  useShowModal({
    modalKey: 'CreateCampaignContactModal',
    options: {
      // @ts-expect-error TS2322
      callbacks: pageContext.callbacks,
    },
  })

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent />

        <CreateOrEditContactModal
          // @ts-expect-error TS2322
          callbacks={callbacks('CreateOrEditContactModal', setState)}
          showModal={showCreateOrEditContactModal}
        />

        <CreateCampaignContactModal
          // @ts-expect-error TS2322
          callbacks={callbacks('CreateCampaignContactModal', setState)}
          showModal={showCreateCampaignContactModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
